import * as Vue from 'vue'

var isVue2 = false
var isVue3 = true

function install() {}

export * from 'vue'
export {
  Vue,
  isVue2,
  isVue3,
  install,
}
